import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Kartable_Order_Interface, Kartable_Order_Interface } from 'src/app/Interface/Kartable_Order_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { KartableService } from 'src/app/Service/Kartable/Kartable.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-KartableController',
  templateUrl: './KartableController.component.html',
  styleUrls: ['./KartableController.component.scss']
})
export class KartableControllerComponent implements OnInit {

  Token:String=""
  PersianToDayDate: String = ""
  BaseUrl = environment.BaseUrl


  Filter_Customer_Order: string = ""
  Filter_RecieveCode_Order: string = ""
  Filter_Certificate_User: string = ""

  Filter_Code2_Order: string = ""
  Filter_Devicename_Order: string = ""
  Filter_Expert_Name_Order: string = ""
  
  Filter_StartSearchDate: string = ""
  Filter_EndSearchDate: string = ""
  
  SubmitPeriodDate: string = '0'
  page_Kartable:0


  constructor(
    private Kartable_Service:KartableService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  Change_Filter_Order() {
    this.page_Kartable = 0
  }


  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1167).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }


  Procssing_Kartable: boolean = false
  DataList_Kartable: Array<Kartable_Order_Interface> = []
  DataList_Kartable_Selected: Kartable_Order_Interface = Empty_Kartable_Order_Interface()
  Data_Seleted_Delete_Status: number = 0
  OperationDsc: string = ''
  modalRef_Delete: any;

  ReadData_Kartable(StartSearchDate, EndSearchDate){

    this.Filter_StartSearchDate=StartSearchDate
    this.Filter_EndSearchDate=EndSearchDate
    this.Procssing_Kartable=true
    this.Kartable_Service.GetController(
      Number(this.SubmitPeriodDate),
      this.Filter_StartSearchDate,
      this.Filter_EndSearchDate,
      this.Token).subscribe(
      data=>{
        this.DataList_Kartable = data

        this.Procssing_Kartable=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  SetCalibrationDetailVisible(item: Kartable_Order_Interface) {
    item.Processing = true

    this.Kartable_Service.SetCalibrationDetailVisible(item.id2, this.Token).subscribe(
      data => {
        item.expert_submit_date_visible=true
        item.Processing = false
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  openModal(template: TemplateRef<any>,Record:Kartable_Order_Interface,Status:number) {
    this.DataList_Kartable_Selected = Record
    this.OperationDsc=""
    this.Data_Seleted_Delete_Status = Status
    this.modalRef_Delete = this.modalService.show(template);
  }

  SubmitController(){
    this.DataList_Kartable_Selected.Processing=true
    this.modalRef_Delete.hide()
    this.Kartable_Service.SubmitController(this.DataList_Kartable_Selected.id2,
      this.Data_Seleted_Delete_Status,
      this.Token,
      this.DataList_Kartable_Selected.customer,
      this.OperationDsc).subscribe(
      data=>{

        this.ReadData_Kartable(this.Filter_StartSearchDate,this.Filter_EndSearchDate)
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#region Device Behfa

  DataList_Kartable_Selected_DeviceBehfa: Kartable_Order_Interface = Empty_Kartable_Order_Interface()

  OnSet_Calibration_DeviceBehfa(item:Kartable_Order_Interface) {
    this.DataList_Kartable_Selected_DeviceBehfa=item
  }

  OnSet_Back_Calibration_DeviceBehfa() {
    this.DataList_Kartable_Selected_DeviceBehfa=Empty_Kartable_Order_Interface()
  }

  //#endregion


  //#region Controller
  Selected_DataList_Calibration: Kartable_Order_Interface = Empty_Kartable_Order_Interface()
  Controller_Data_List:Array<General_Interface>=[]
  modalRef_Controller: any;

  openModal_Controller(template: TemplateRef<any>,item:Kartable_Order_Interface) {
    this.modalRef_Controller = this.modalService.show(template);
    this.Selected_DataList_Calibration=item
    this.Controller_Data_List=item.controller
  }

  //#endregion

}
